import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { HttpService } from './http.service';
import { StorageService } from './storage.service';
import { TranslateService } from '@ngx-translate/core';

import { FormTypeText } from '../models/form/form-type-text';
import { FormTypeDate } from '../models/form/form-type-date';
import { FormTypeNum } from '../models/form/form-type-num';

@Injectable()
export class MetaDataService {

    private SYS_METADATA_KEY = 'meta_data';

    private _data;
    get data() { return this._data; }
    set data(value) { this.setData(value); }

    set langs(data) {
        this.setLang(data, 'zh-CN', 'displayNameCN');
        this.setLang(data, 'zh-TW', 'displayNameTW');
        this.setLang(data, 'en-US', 'displayNameUN');
        this.setLang(data, 'vi', 'displayNameVI');
    }

    constructor(
        private http: HttpService,
        private storageService: StorageService,
        private translate: TranslateService
    ) {
        this.init();
    }

    init() {
        if (this.data) return;
        // this.storageService.storage.getItem(this.SYS_METADATA_KEY).then(value => {
        //     if (value) {
        //         const res = JSON.parse(value);
        //         this.data = res;
        //         this.langs = res;
        //     } else {
        //         this.fetchData().toPromise().then(res => {
        //             if (this.data) return;
        //             this.data = res;
        //             this.langs = res;
        //             this.storageService.storage.setItem(this.SYS_METADATA_KEY, JSON.stringify(res));
        //         });
        //     }
        // });
        this.fetchData().toPromise().then(res => {
            if (this.data) return;
            this.data = res;
            this.langs = res;
        });
    }

    private fetchData() {
        return this.http.get('api/open/extendWordList', {})
            .switchMap(res => this.http.mapRes(res));
    }

    private setData(value) {
        this._data = {};
        if (_.isArray(value)) {
            _.each(value, x => {
                if (x.items && x.items.length) {
                    this._data[x.key] = x.items || [];
                }
            });
        }
    }

    private setLang(data, lang, field) {
        const langItem = { extension: {} };
        _.each(data, c => {
            const obj = {};
            _.each(c.items, item => {
                obj[item.name] = item[field];
            });
            langItem.extension[c.key] = obj;
        });
        this.translate.setTranslation(lang, langItem, true);
    }

    getOption(option, key) {
        if (!option) return null;
        const obj = {
            key: key,
            fieldCode: option.name
            // order: option.order
        };
        switch (option.type) {
            case 'text':
                return new FormTypeText(obj);
            case 'number':
                return new FormTypeNum(obj);
            case 'date':
                return new FormTypeDate(obj);
            default:
                return new FormTypeText(obj);
        }
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/meta-data.service.ts